export default "<p>product-details works!</p>\n"